<template>
  <div>
    <b-container fluid class="general_block">
      <b-form @submit.prevent="onSubmit">
        <b-row align-h="around" class="m-3 px-2" style="justify-content: center;">
          <b-col cols="5">
            <b-form-select
              v-model="type_selected" 
              :options="options" >
            </b-form-select>
              <!-- <div class="mt-3">Selected: <strong>{{ type_selected }}</strong></div> -->
          </b-col>
          <b-col cols="5">
            <autocomplete
              class="auto_complete"
              :disableInput="type_selected ? false : true"
              :source="get_list" 
              @selected="change_next_select">
            </autocomplete>
          </b-col>
        </b-row>

          <b-row align-h="around" align-v="center" class="mx-3 mb-2 or-form" style="justify-content: center;">
            <b-col align-self="center" class="text-center" cols="5">
              <b-row align-v="center" align-h="center">
                <label for="mutation" class="mx-auto mt-1">Enter a missense protein mutation:</label>
              </b-row>
              <b-row align-v="center" align-h="center">
                <b-form-input class="mx-auto" style="width: 400px" 
                  id="mutation" 
                  v-model="mut" 
                  placeholder="e.g., p.G560V, Gly560Val"
                  :disabled="entry_id ? false : true"
                  v-on:click="reset_domain_select"
                  >
                </b-form-input>
              </b-row>
              <!-- <p id="mutation2" class="mt-2"><span v-html="rawHtml"></span></p> -->
              <p v-if="typeof (IsInDom) === 'string'" id="mutation2" class="mt-2" style="font-weight: 400; font-size: 0.8rem;">
                <span v-if="IsInDom === 'no_dom'" style="color: red;">Mutation not in protein domain</span>
                <span v-else-if="IsInDom === 'wrong_format'" style="color: red;">Wrong mutation format</span>
              </p>
            </b-col>

            <b-col class="text-center" cols="2">
              <p>OR</p>
            </b-col>

            <b-col align-self="center" class="text-center" cols="5">
              <b-row align-h="center">
                <label for="sel_domain" class="mx-auto mt-1">Choose a protein domain:</label>
              </b-row>
              <b-row align-v="center" align-h="center">
                <b-form-select class="mx-auto" style="width: 400px" 
                  id="sel_domain" 
                  v-model="dom"
                  :options="dom_option"
                  :disabled="entry_id ? false : true"
                  >
                </b-form-select>
              </b-row>
            </b-col>
          </b-row>

      </b-form>
    </b-container>

    <!-- <b-container class="mt-5" v-if="entry_id != null && (mut != null || dom != null)">
      <b-overlay :show="dom_selected == null"></b-overlay>
    </b-container> -->
    
      <block-component 
        v-if="dom_selected != null && typeof (IsInDom) != 'string'"
        :entry-id="entry_id"
        :dom-selected="dom_selected"
        :mut="mut"
        :key="ck"
        :ck="ck"
        :dom="dom"
        >
      </block-component>
  
  </div>
  
</template>


  <script>
  document.body.style.zoom = "80%";
  // $('body').css({ width: '50%' });
  import Autocomplete from 'vuejs-auto-complete';
  export default {
    components: {
      Autocomplete
    },
    data() {
      return {
        type_selected: false,
        mut: null,
        entry_id: null,
        write: '',

        // mut: 'p.S96C',
        // entry_id: 'A0A024R161_HUMAN',

        //type_selected: 'a',
        //entry_id: 'FBN1_HUMAN',
        //dom: 'PF00683',
        //mut: 'p.G560V',

        dom: null,
        dom_selected: null,
        dom_option: null,
        isButtonDisabled: true,
        // rawHtml: null,
        //mut_o_pfid: null,
        IsInDom: [],
        options: [
        { value: false, text: 'Please select an ID type' },
        { value: 'a', text: 'Gene Name' },
        { value: 'b', text: 'Ensembl ID'},
        { value: 'c', text: 'RefSeq ID'},
        { value: 'd', text: 'Uniprot ID' }
        ],
        // showDismissibleAlert: false,
        ck: 0,
      }
    },
    mounted() {
      console.log('SELECT SEARCH Component mounted.')
      this.mutIsInDom(this.mut,this.entry_id)
      this.get_data_for_dom(this.dom,this.entry_id)
    },
    watch: {
      mut: function(){
        if(this.mut != null){
          this.mut = this.mut.trim()
          //this.change_button_satut()
          var hgvsp1 = new RegExp('^(p\.)?[ACDEFGHIKLMNPQRSTVWYacdefghiklmnpqrstvwy]{1}[0-9]+[ACDEFGHIKLMNPQRSTVWYacdefghiklmnpqrstvwy]{1}$', 'i')
          var hgvsp3 = new RegExp('^(p\.)?[A-Za-z]{3}[0-9]+[A-Za-z]{3}$', 'i')
          if (this.mut!='' &&  (hgvsp1.test(this.mut) || hgvsp3.test(this.mut))) {
            this.mutIsInDom(this.mut,this.entry_id)
          }
        }
      },
      dom: function(){
        this.mut = null
        this.dom_selected = null
        this.get_data_for_dom(this.dom,this.entry_id)
        
      },
      type_selected: function(){
        this.mut = null
        this.dom = null
        this.entry_id = null
        this.dom_selected = null  
      },
    
      IsInDom:{
        handler:function(){
          var hgvsp1 = new RegExp('^(p\.)?[ACDEFGHIKLMNPQRSTVWYacdefghiklmnpqrstvwy]{1}[0-9]+[ACDEFGHIKLMNPQRSTVWYacdefghiklmnpqrstvwy]{1}$', 'i')
          var hgvsp3 = new RegExp('^(p\.)?[A-Za-z]{3}[0-9]+[A-Za-z]{3}$', 'i')
          if (this.mut!='' && (hgvsp1.test(this.mut) || hgvsp3.test(this.mut)) && typeof (this.IsInDom) != 'string') {
            $('#mutation').css('border-style', 'solid').css('border-color', 'green')
            // console.log('Good Submit !')
            this.dom_selected = this.IsInDom
            //console.log(this.dom_selected)
            // this.rawHtml = '<span></span>'
          // }else if (this.mut!='' && (hgvsp1.test(this.mut) || hgvsp3.test(this.mut)) && this.IsInDom === 'no_dom') {
          //   this.rawHtml = '<span style="color: red">Mutation not in protein domain</span>'
          //   $('#mutation').css('border-style', 'solid').css('border-color', 'red')
          //   // this.showDismissibleAlert = true;
          // }else if(this.mut!='' && (hgvsp1.test(this.mut) || hgvsp3.test(this.mut)) && this.IsInDom === 'wrong_format'){
          //   this.rawHtml = '<span style="color: red">Wrong mutation format</span>'
          //   $('#mutation').css('border-style', 'solid').css('border-color', 'red')
          }else if(typeof (this.IsInDom) === 'string'){
            $('#mutation').css('border-style', 'solid').css('border-color', 'red')
          }else{
            // console.log('Wrong Submit !')
            // this.rawHtml = '<span style="color: red">Error in hgvsp format</span>'
            $('#mutation').css('border-style', 'solid').css('border-color', 'red')
          }
        },
        deep:true
      }
    },

    methods:{
      get_list(input) {
        input = input.trim()
        if (typeof input != undefined && input != ''){
          return "/main/get_list/"+this.type_selected+"/"+input
        }
        return noResults;
      },
      change_next_select(input){
        this.reset_domain_select()
        this.dom_option = [{id: 0,text:'Please select a domain',value:null}]
        this.entry_id = input.value
        //console.log(input.value)
        axios
          .get("/main/get_all_dom/"+input.value)
          .then(response => (this.dom_option = response.data))
          .catch(error => console.log(error))
      },
      mutIsInDom(mut,entry_id){
        if (mut == null || entry_id == null) {
          return null;
        }
        axios
          .get("/main/mut_is_in_dom/"+mut+"/"+entry_id)
          .then( ({data}) => {
            this.IsInDom = data 
            this.ck++
            //console.log(data)   
          })
          .catch(error => console.log(error))
      },
      reset_domain_select(){
        this.dom_selected = null
        this.dom = null
        
      },
      get_data_for_dom(pfid,entry_id){
        if (pfid == null || entry_id == null) {
          return null;
        }
        axios
          .get("/main/get_data_for_dom/"+pfid+"/"+entry_id)
          .then( ({data}) => {
            this.dom_selected = data 
            this.ck++
            //console.log(data)   
          })
          .catch(error => console.log(error))
      }
  }
}
</script> 
